<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460" content-class="rounded-xl">
		<v-card>
			<v-card-title class="font-size-13 justify-center orange--text">Peringatan !</v-card-title>
			<v-card-text class="text-center">
				<div class="font-size-11">Jumlah produk tidak boleh melebihi jumlah serial</div>
			</v-card-text>
			<v-card-actions class="pb-3">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined class="text-capitalize rounded-xl" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			closeText: 'Mengerti',
		}
	},
	props: {
		msg: String,
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
	}
};
</script>